import type { IAdminDashboardRepository } from "@/application/ports/repositories";
import type { AdminDashboardStats } from "@/domain/admin";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class AdminDashboardRepository implements IAdminDashboardRepository {
  async getStats(): Promise<AdminDashboardStats> {
    return unwrap(sdk.getDashboardStats());
  }
}
